import { BaseComponent } from '../../base-component';

export class UpInfoComponent extends BaseComponent {
    public rootSelector = '.js_pdp_up-info';
    public static shippingCostsProgressBarSelector = '.js_pdp_up-info__shipping-costs-progress-bar'; // FT1 uses it, do not change without their knowledge

    public async init(): Promise<void> {
        return;
    }

    public async onHtmlLoaded(): Promise<void> {
        if (!this.isPresent()) {
            return;
        }
        const variationId = this.getRootElement().dataset.variationId || '';
        this.sendUpTeaserTargetEvent(variationId);
        this.sendUpPointsBannerTargetEvent(variationId);
    }

    private sendUpTeaserTargetEvent(variationId: string): void {
        const targetElementBottom = this.getChildElement('.js_pdp_up-info__up-teaser-target');
        o_global.eventQBus.emit('ft9.up-teaser.variationChanged', {
            variationId,
            targetElement: targetElementBottom,
        });
    }

    private sendUpPointsBannerTargetEvent(variationId: string): void {
        const targetElement = this.getChildElement('.js_pdp_up-info__up-points-banner__target');
        o_global.eventQBus.emit('ft9.up-teaser-info-banner.variationChanged', {
            variationId,
            targetElement: targetElement,
        });
    }
}
